import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles, TrendingUp, Users, Globe2, Package, Palette, Award, UserPlus, Download, Key, CheckCircle, X, Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { VideoPlayer } from '../components/VideoPlayer';
import { useAnalytics } from '../hooks/useAnalytics';
const sampleProperties = [{
  id: 'doge',
  name: 'Own the Doge',
  description: 'Iconic internet meme with massive cultural impact and recognition',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9GcybqBX3XwepUjNjqSxwK/Frame_3.jpg',
  galleryImages: ['https://uploadthingy.s3.us-west-1.amazonaws.com/9GcybqBX3XwepUjNjqSxwK/Frame_3.jpg'],
  category: 'Meme',
  badge: 'TRENDING ON TIKTOK',
  stats: {
    reach: '20M+ Social Reach',
    engagement: 'DOGE NFT sold for $4.24Million + Monument in Japan',
    trend: 'International Doge Day Japan yearly in November'
  }
}, {
  id: 'national-lampoon',
  name: 'National Lampoon',
  description: 'Legendary comedy brand with decades of entertainment history',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hSesjsbp2NtKiS2hfArUZ2/2d48979a-ab38-45a8-a694-64074b9b0d72.webp',
  galleryImages: ['https://uploadthingy.s3.us-west-1.amazonaws.com/6YjQpLzsjA56uDssy6GJo4/download_%284%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6nHDXapGKiTZny7wCooTm2/download_%286%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/kTAJ96Z4pVekTTmsmNCJrh/download_%285%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hvGnkm9BdUMTqXh1GL7xR2/download_%283%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/98MKhSkeYtSEdiHQD5M7bg/download_%282%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/fvXSHkAUco7hbzEyueY69n/10.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6n85Hcj3uzjtg7vcgPubFQ/Clarks-Tree-Farm-national-lampoon1.png'],
  category: 'Comedy',
  badge: 'Comedy Legend',
  stats: {
    reach: '15M+ Fan Base',
    engagement: 'Over $1Billion in revenues (inflation adjusted)',
    trend: '50-year archive of print, audio, and video content'
  }
}, {
  id: 'luchadores',
  name: 'Masked Republic® Luchadores',
  description: 'Legendary Mexican wrestlers with iconic mask designs and global recognition',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyxTQ79ziHounyFF179ZxM/Copy_of_MR_Logo-vector-2_%281%29.jpg',
  galleryImages: ['https://uploadthingy.s3.us-west-1.amazonaws.com/svofvPChbum4C7U7F9vvZR/Fullcolor.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/rp2ptiErq3JfJDT1RYwX4F/FullLineart.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8nGzFBgU718Q8uCVcwUUiJ/Fullcolor.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hbXiQmq8xfjmXC2sN7y4ps/FullLineart.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/csRchHk1SnL3xuXdhKe4rY/TigreMaskColorBackLogo.jpg'],
  category: 'Sports',
  badge: 'Popular in South America',
  stats: {
    reach: 'Second most popular sport in Mexico',
    engagement: '100+ Year Heritage',
    trend: '2026 US Tour featuring Vampiro & Tigre W'
  }
}];
export function LandingPage() {
  const navigate = useNavigate();
  const {
    trackEvent
  } = useAnalytics();
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  useEffect(() => {
    // Set page title
    document.title = 'Spaceport - Premium IP Licensing for Printify';
  }, []);
  const handleMouseMove = (e: React.MouseEvent<HTMLHeadingElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  const handleJoinEarlyAccess = () => {
    trackEvent('cta_click', {
      button_name: 'join_early_access',
      location: 'hero'
    });
    window.location.href = 'https://portal.spaceport.xyz/license/buy/bundle/eJwNyskRwDAIBLCGsjOA1wflcDj9l5DoLbXNfU3h4wg43kSe5aCEU1m62h7e3X1XYwyf4CQR1oVZFWGSOv7kO7skDZU3QTOBKxsaPNn6Rm35APmKHI8?distributionAuth=printify';
  };
  const handleBrowseCatalog = () => {
    trackEvent('navigation_click', {
      button_name: 'browse_catalog',
      location: 'hero'
    });
    const catalogSection = document.querySelector('#ip-catalog');
    catalogSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleWatchTutorial = () => {
    trackEvent('video_open', {
      video_name: 'tutorial',
      location: 'hero'
    });
    setIsVideoModalOpen(true);
  };
  const handleCloseVideo = () => {
    trackEvent('video_close', {
      video_name: 'tutorial',
      location: 'hero'
    });
    setIsVideoModalOpen(false);
  };
  const handlePropertyClick = (property: (typeof sampleProperties)[0]) => {
    trackEvent('property_click', {
      property_id: property.id,
      property_name: property.name,
      location: 'catalog'
    });
    navigate(`/property/${property.id}`);
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-73">
      {/* Hero Section */}
      <section className="relative w-full min-h-screen md:h-[85vh] flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900 py-8 md:py-0 pb-0" data-id="element-74">
        {/* Background collage of IP assets with horizontal scrolling animation */}
        <div className="absolute inset-0 opacity-25" data-id="element-75">
          {sampleProperties.flatMap((property, propertyIndex) => property.galleryImages.slice(0, 3).map((galleryImage, imageIndex) => {
          const index = propertyIndex * 3 + imageIndex;
          const positions = [{
            top: '5%',
            left: '5%',
            duration: 40,
            delay: 0,
            size: '40vh',
            initialX: 0
          }, {
            top: '35%',
            right: '15%',
            duration: 35,
            delay: 3,
            size: '40vh',
            initialX: 200
          }, {
            bottom: '8%',
            left: '20%',
            duration: 45,
            delay: 6,
            size: '40vh',
            initialX: 400
          }, {
            top: '12%',
            right: '8%',
            duration: 38,
            delay: 2,
            size: '35vh',
            initialX: 150
          }, {
            bottom: '25%',
            right: '35%',
            duration: 42,
            delay: 5,
            size: '38vh',
            initialX: 350
          }, {
            top: '40%',
            left: '12%',
            duration: 37,
            delay: 4,
            size: '36vh',
            initialX: 250
          }, {
            bottom: '18%',
            left: '45%',
            duration: 43,
            delay: 7,
            size: '37vh',
            initialX: 450
          }, {
            top: '22%',
            right: '28%',
            duration: 39,
            delay: 1,
            size: '39vh',
            initialX: 100
          }, {
            bottom: '32%',
            right: '5%',
            duration: 41,
            delay: 8,
            size: '35vh',
            initialX: 500
          }];
          const position = positions[index % positions.length];
          return <motion.div key={`${property.id}-${imageIndex}`} className={`absolute z-${10 + index * 5} ${index > 5 ? 'hidden md:block' : ''}`} style={{
            width: position.size,
            height: position.size,
            filter: 'blur(0px)',
            willChange: 'transform',
            transform: 'translateZ(0)',
            ...(position.top && {
              top: position.top
            }),
            ...(position.bottom && {
              bottom: position.bottom
            }),
            ...(position.left && {
              left: position.left
            }),
            ...(position.right && {
              right: position.right
            })
          }} initial={{
            x: position.initialX,
            opacity: 0
          }} animate={{
            x: [position.initialX, position.initialX - 1000],
            opacity: 1
          }} transition={{
            x: {
              duration: position.duration,
              repeat: Infinity,
              ease: 'linear',
              delay: position.delay
            },
            opacity: {
              duration: 0.5,
              delay: position.delay
            }
          }} data-id="element-76">
                    <div className="w-full h-full bg-white rounded-3xl p-4 shadow-2xl" data-id="element-77">
                      <img src={galleryImage} alt="" className="w-full h-full object-contain" data-id="element-78" />
                    </div>
                  </motion.div>;
        }))}
        </div>
        {/* Animated background */}
        <div className="absolute inset-0 opacity-20" data-id="element-79">
          <motion.div className="absolute w-96 h-96 rounded-full blur-3xl bg-blue-500" animate={{
          x: [0, 100, 0],
          y: [0, 50, 0]
        }} transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          top: '20%',
          left: '10%',
          willChange: 'transform',
          transform: 'translateZ(0)'
        }} data-id="element-80" />
          <motion.div className="absolute w-80 h-80 rounded-full blur-3xl bg-purple-500" animate={{
          x: [0, -80, 0],
          y: [0, 60, 0]
        }} transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          bottom: '20%',
          right: '10%',
          willChange: 'transform',
          transform: 'translateZ(0)'
        }} data-id="element-81" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full py-12 md:py-20 -mt-[150px] md:mt-0 -mb-[100px] md:mb-0" data-id="element-82">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} className="mb-8 md:mb-12" data-id="element-83">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/64JBjBQwTxv1wFV6Qexq11/Group_1000011127.png" alt="Spaceport" className="h-8 md:h-12 lg:h-16 w-auto object-contain" data-id="element-84" />
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} onMouseMove={handleMouseMove} className="text-4xl md:text-6xl lg:text-8xl font-bold text-white mb-6 md:mb-8 tracking-tight relative cursor-default" data-id="element-85">
            <span className="relative" data-id="element-86">
              <motion.span className="absolute inset-0 blur-2xl opacity-30" style={{
              background: `radial-gradient(circle 200px at ${mousePosition.x}px ${mousePosition.y}px, rgba(59, 130, 246, 0.8), transparent)`
            }} data-id="element-87" />
              EASILY LICENSE
              <br className="md:hidden" data-id="element-88" /> TOP IP
              <br className="md:hidden" data-id="element-89" /> FOR YOUR
              <br className="md:hidden" data-id="element-90" />{' '}
              <span className="relative inline-block" data-id="element-91">
                <span className="relative z-10 bg-gradient-to-r from-blue-400 via-blue-500 to-cyan-400 bg-clip-text text-transparent" data-id="element-92">
                  DESIGNS
                </span>
                <span className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-cyan-400 blur-xl opacity-50" data-id="element-93" />
              </span>
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3
        }} className="text-base md:text-xl text-gray-300 mb-8 md:mb-10 max-w-3xl" data-id="element-94">
            Spaceport partners with Printify to bring world-class intellectual
            property to your print-on-demand business. Get your license today
            and start accessing exclusive brands, transparent licensing, and
            instant approvals.
          </motion.p>
          <div className="flex flex-col md:flex-row gap-4" data-id="element-95">
            <motion.button initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.4
          }} onClick={() => window.location.href = 'https://portal.spaceport.xyz/license/buy/bundle/eJwNyskRwDAIBLCGsjOA1wflcDj9l5DoLbXNfU3h4wg43kSe5aCEU1m62h7e3X1XYwyf4CQR1oVZFWGSOv7kO7skDZU3QTOBKxsaPNn6Rm35APmKHI8?distributionAuth=printify'} className="flex items-center justify-center gap-3 px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-2xl font-light rounded-full hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 w-full md:w-auto whitespace-nowrap" data-id="element-96">
              <span data-id="element-97">Get Your License</span>
              <ArrowRight className="w-6 h-6" data-id="element-98" />
            </motion.button>
            <motion.button initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.45
          }} onClick={() => {
            trackEvent('navigation_click', {
              button_name: 'browse_catalog',
              location: 'hero'
            });
            const catalogSection = document.querySelector('#ip-catalog');
            catalogSection?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="flex items-center justify-center gap-3 px-8 py-3 bg-white text-black text-2xl font-light rounded-full hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 w-full md:w-auto whitespace-nowrap" data-id="element-99">
              <span data-id="element-100">Browse Catalog</span>
              <ArrowRight className="w-6 h-6" data-id="element-101" />
            </motion.button>
            <motion.button initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.5
          }} onClick={() => {
            trackEvent('video_open', {
              video_name: 'tutorial',
              location: 'hero'
            });
            setIsVideoModalOpen(true);
          }} className="flex items-center justify-center gap-3 px-8 py-3 bg-white text-black text-2xl font-light rounded-full hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 w-full md:w-auto whitespace-nowrap" data-id="element-102">
              <Play className="w-6 h-6" fill="currentColor" data-id="element-103" />
              <span data-id="element-104">Watch Tutorial</span>
            </motion.button>
          </div>
        </div>
      </section>
      {/* Program Benefits Section */}
      <section className="w-full py-16 px-6 bg-gradient-to-br from-blue-600 via-blue-700 to-purple-600 md:mt-0 relative z-10" data-id="element-105">
        <div className="max-w-7xl mx-auto" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-12" data-id="element-107">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-108">
              PROGRAM BENEFITS
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-109">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-110">
              <Award className="w-10 h-10 text-cyan-300 mb-4" data-id="element-111" />
              <p className="text-white font-semibold text-lg" data-id="element-112">
                No minimum guarantees
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-113">
              <Palette className="w-10 h-10 text-blue-300 mb-4" data-id="element-114" />
              <p className="text-white font-semibold text-lg" data-id="element-115">
                Fast approvals within 24 hours
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-116">
              <Globe2 className="w-10 h-10 text-purple-300 mb-4" data-id="element-117" />
              <p className="text-white font-semibold text-lg" data-id="element-118">
                No geographic restrictions
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-119">
              <Package className="w-10 h-10 text-pink-300 mb-4" data-id="element-120" />
              <p className="text-white font-semibold text-lg" data-id="element-121">
                No product restrictions
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all" data-id="element-122">
              <Sparkles className="w-10 h-10 text-yellow-300 mb-4" data-id="element-123" />
              <p className="text-white font-semibold text-lg" data-id="element-124">
                All sales channels supported
              </p>
            </motion.div>
          </div>
        </div>
      </section>
      {/* IP Catalog Section */}
      <section id="ip-catalog" className="w-full py-32 px-6 bg-gray-100" data-id="element-125">
        <div className="max-w-7xl mx-auto" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-16" data-id="element-127">
            <h2 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6" data-id="element-128">
              PREMIUM IP CATALOG
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl" data-id="element-129">
              Explore our curated collection of premium intellectual properties
              available for licensing through Printify.
            </p>
          </motion.div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-130">
            {sampleProperties.map((property, index) => <motion.div key={property.id} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} onClick={() => {
            trackEvent('property_click', {
              property_id: property.id,
              property_name: property.name,
              location: 'catalog'
            });
            navigate(`/property/${property.id}`);
          }} className="bg-white rounded-2xl overflow-hidden cursor-pointer hover:shadow-2xl transition-all duration-300 group" data-id="element-131">
                <div className="relative aspect-square overflow-hidden" data-id="element-132">
                  <img src={property.image} alt={property.name} className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500" data-id="element-133" />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold" data-id="element-134">
                    {property.category}
                  </div>
                  <div className="absolute top-4 left-4 bg-green-500/90 backdrop-blur-sm px-3 py-2 rounded-full text-white text-xs font-bold flex items-center gap-1.5" data-id="element-135">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-136" />
                    {property.badge}
                  </div>
                </div>
                <div className="p-6" data-id="element-137">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-138">
                    {property.name}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-139">{property.description}</p>
                  <div className="space-y-3 pt-4 border-t border-gray-100" data-id="element-140">
                    <div className="space-y-1" data-id="element-141">
                      <span className="text-xs uppercase tracking-wider text-gray-500 font-medium block" data-id="element-142">
                        Reach
                      </span>
                      <span className="text-sm font-semibold text-gray-900 block" data-id="element-143">
                        {property.stats.reach}
                      </span>
                    </div>
                    <div className="space-y-1" data-id="element-144">
                      <span className="text-xs uppercase tracking-wider text-gray-500 font-medium block" data-id="element-145">
                        Impact
                      </span>
                      <span className="text-sm font-semibold text-gray-900 block leading-snug" data-id="element-146">
                        {property.stats.engagement}
                      </span>
                    </div>
                    <div className="space-y-1" data-id="element-147">
                      <span className="text-xs uppercase tracking-wider text-gray-500 font-medium block" data-id="element-148">
                        Growth
                      </span>
                      <span className="text-sm font-semibold text-green-600 flex items-start gap-1.5 leading-snug" data-id="element-149">
                        <TrendingUp className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" data-id="element-150" />
                        <span data-id="element-151">{property.stats.trend}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section className="w-full py-20 px-6 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden" data-id="element-152">
        <div className="max-w-7xl mx-auto" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-4" data-id="element-154">
            <h2 className="text-5xl md:text-7xl font-bold text-white mb-6" data-id="element-155">
              HOW IT WORKS
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mb-8" data-id="element-156">
              A Simple 5-Step Guide to Licensing Premium IP
            </p>
            <motion.button initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} onClick={handleWatchTutorial} className="group relative overflow-hidden rounded-2xl hover:shadow-2xl hover:shadow-blue-500/30 transition-all duration-300" data-id="element-157">
              <div className="relative" data-id="element-158">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ZeS484CZ51sFU1jp32kEn/Screenshot_2025-11-04_at_12.01.46_PM.png" alt="Watch Tutorial" className="w-full max-w-2xl h-auto rounded-2xl" data-id="element-159" />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center rounded-2xl" data-id="element-160">
                  <div className="w-20 h-20 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-161">
                    <Play className="w-10 h-10 text-gray-900 ml-1" fill="currentColor" data-id="element-162" />
                  </div>
                </div>
                <div className="hidden md:block absolute bottom-6 left-6 text-left" data-id="element-163">
                  <div className="text-white text-2xl font-bold mb-1" data-id="element-164">
                    WATCH THE TUTORIAL
                  </div>
                  <div className="text-gray-200 text-sm" data-id="element-165">
                    Learn how to publish licensed products on Printify
                  </div>
                </div>
              </div>
              <div className="md:hidden mt-4 text-left" data-id="element-166">
                <div className="text-white text-2xl font-bold mb-1" data-id="element-167">
                  WATCH THE TUTORIAL
                </div>
                <div className="text-gray-200 text-sm" data-id="element-168">
                  Learn how to publish licensed products on Printify
                </div>
              </div>
            </motion.button>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-169">
            {/* Left 50% - Steps */}
            <div className="relative space-y-14" data-id="element-170">
              {/* Vertical Timeline Line */}
              <div className="absolute left-[40px] top-[80px] bottom-[80px] w-0.5 bg-gradient-to-b from-blue-600 via-purple-600 to-blue-600 opacity-30" data-id="element-171" />
              {[{
              number: '1',
              icon: UserPlus,
              title: 'Sign Up & Connect',
              description: "Create your Spaceport account and connect your Printify store in seconds. It's quick, easy, and secure."
            }, {
              number: '2',
              icon: Download,
              title: 'Get Official Artwork',
              description: 'Browse iconic brands with millions of passionate fans. Download high-resolution, pre-approved artwork ready to use.'
            }, {
              number: '3',
              icon: Palette,
              title: 'Design & Sell',
              description: 'Use official brand assets as your foundation to create unique, original designs in Printify. Remix, combine, and customize to make products that stand out. Design once, sell everywhere your store is connected.'
            }, {
              number: '4',
              icon: Key,
              title: 'Link Your License',
              description: 'Copy your unique Spaceport License ID and paste it into your Printify product description. This simple step connects everything for approval.'
            }, {
              number: '5',
              icon: CheckCircle,
              title: 'Get Approved Fast',
              description: 'Your design gets reviewed within 24 hours. Once approved, you\'ll get an email notification. Then just hit "Publish" in Printify and start selling!'
            }].map((step, index) => <motion.div key={step.number} initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-6 items-start group py-4" data-id="element-172">
                  <div className="flex-shrink-0" data-id="element-173">
                    <div className="relative" data-id="element-174">
                      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center text-white text-xl font-bold group-hover:scale-110 transition-transform duration-300" data-id="element-175">
                        {step.number}
                      </div>
                      <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-600 to-purple-600 blur-xl opacity-50 group-hover:opacity-75 transition-opacity" data-id="element-176" />
                    </div>
                  </div>
                  <div className="flex-1 pt-2" data-id="element-177">
                    <div className="flex items-center gap-4 mb-3" data-id="element-178">
                      <step.icon className="w-8 h-8 text-blue-400" data-id="element-179" />
                      <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-180">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-sm text-gray-300 leading-relaxed" data-id="element-181">
                      {step.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
            {/* Right 50% - Vertically Scrolling Images */}
            <div className="relative hidden lg:block" data-id="element-182">
              <div className="absolute inset-0 opacity-30" data-id="element-183">
                {sampleProperties.flatMap((property, propertyIndex) => property.galleryImages.slice(0, 3).map((galleryImage, imageIndex) => {
                const index = propertyIndex * 3 + imageIndex;
                const positions = [{
                  left: '10%',
                  top: '0%',
                  duration: 40,
                  delay: 0,
                  size: '30vh',
                  initialY: 0,
                  translateY: -1000
                }, {
                  right: '10%',
                  top: '20%',
                  duration: 35,
                  delay: 3,
                  size: '30vh',
                  initialY: 200,
                  translateY: -1200
                }, {
                  left: '25%',
                  top: '40%',
                  duration: 45,
                  delay: 6,
                  size: '28vh',
                  initialY: 400,
                  translateY: -900
                }, {
                  right: '20%',
                  top: '10%',
                  duration: 38,
                  delay: 2,
                  size: '32vh',
                  initialY: 150,
                  translateY: -1100
                }, {
                  left: '15%',
                  top: '30%',
                  duration: 42,
                  delay: 5,
                  size: '29vh',
                  initialY: 350,
                  translateY: -950
                }, {
                  right: '15%',
                  top: '50%',
                  duration: 37,
                  delay: 4,
                  size: '31vh',
                  initialY: 250,
                  translateY: -1050
                }, {
                  left: '20%',
                  top: '15%',
                  duration: 43,
                  delay: 7,
                  size: '28vh',
                  initialY: 450,
                  translateY: -1150
                }, {
                  right: '25%',
                  top: '35%',
                  duration: 39,
                  delay: 1,
                  size: '30vh',
                  initialY: 100,
                  translateY: -1000
                }, {
                  left: '30%',
                  top: '25%',
                  duration: 41,
                  delay: 8,
                  size: '29vh',
                  initialY: 500,
                  translateY: -1100
                }];
                const position = positions[index % positions.length];
                return <motion.div key={`${property.id}-${imageIndex}`} className="absolute" style={{
                  width: position.size,
                  height: position.size,
                  filter: 'blur(0px)',
                  willChange: 'transform',
                  transform: 'translateZ(0)',
                  ...(position.left && {
                    left: position.left
                  }),
                  ...(position.right && {
                    right: position.right
                  }),
                  top: position.top
                }} initial={{
                  y: position.initialY,
                  opacity: 0
                }} animate={{
                  y: [position.initialY, position.translateY],
                  opacity: 1
                }} transition={{
                  y: {
                    duration: position.duration,
                    repeat: Infinity,
                    ease: 'linear',
                    delay: position.delay
                  },
                  opacity: {
                    duration: 0.5,
                    delay: position.delay
                  }
                }} data-id="element-184">
                          <div className="w-full h-full bg-white rounded-3xl p-4 shadow-2xl" data-id="element-185">
                            <img src={galleryImage} alt="" className="w-full h-full object-contain" data-id="element-186" />
                          </div>
                        </motion.div>;
              }))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Value Props */}
      <section className="w-full py-32 px-6 bg-white" data-id="element-187">
        <div className="max-w-7xl mx-auto" data-id="element-188">
          <h2 className="text-5xl md:text-7xl font-bold text-gray-900 mb-20 text-center" data-id="element-189">
            WHY SPACEPORT X PRINTIFY?
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-190">
            {[{
            icon: Sparkles,
            title: 'Tap Into a Global Fanbase',
            description: 'Stop guessing what will sell. Get access to brands with millions of passionate fans who are ready to buy your products. Every design comes with a built-in audience.'
          }, {
            icon: TrendingUp,
            title: 'Simple, Risk-Free Pricing',
            description: 'No upfront fees or hidden costs. You only pay a simple royalty on what you sell. Start creating products today without any financial risk.'
          }, {
            icon: Users,
            title: 'Sell With Confidence',
            description: 'We handle product approvals, legal compliance, and royalty payments automatically. Focus on creating and selling while we take care of the hard stuff.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300" data-id="element-191">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center mb-6" data-id="element-192">
                  <item.icon className="w-8 h-8 text-white" data-id="element-193" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-194">
                  {item.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-195">
                  {item.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="w-full py-32 px-6 bg-gradient-to-br from-gray-900 to-black" data-id="element-196">
        <div className="max-w-4xl mx-auto text-center" data-id="element-197">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-5xl md:text-7xl font-bold text-white mb-8" data-id="element-198">
            READY TO GET STARTED?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-300 mb-12" data-id="element-199">
            Get your license for any of our premium IP properties today.
          </motion.p>
          <motion.button initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} onClick={() => window.location.href = 'https://portal.spaceport.xyz/license/buy/bundle/eJwNyskRwDAIBLCGsjOA1wflcDj9l5DoLbXNfU3h4wg43kSe5aCEU1m62h7e3X1XYwyf4CQR1oVZFWGSOv7kO7skDZU3QTOBKxsaPNn6Rm35APmKHI8?distributionAuth=printify'} className="flex items-center justify-center gap-3 px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-2xl font-light rounded-full hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 mx-auto whitespace-nowrap" data-id="element-200">
            <span data-id="element-201">Get Your License</span>
            <ArrowRight className="w-6 h-6" data-id="element-202" />
          </motion.button>
        </div>
      </section>
      {/* Video Modal */}
      {isVideoModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={handleCloseVideo} data-id="element-203">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="relative w-full max-w-5xl" onClick={e => e.stopPropagation()} data-id="element-204">
            <button onClick={handleCloseVideo} className="absolute -top-12 right-0 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors" data-id="element-205">
              <X className="w-6 h-6" data-id="element-206" />
            </button>
            <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl" data-id="element-207">
              <VideoPlayer src="https://video.squarespace-cdn.com/content/v1/6356d3a6954945102e51363f/b6b40d9c-68b1-44cb-99c2-3ca936c099b9/playlist.m3u8" autoPlay={true} controls={true} data-id="element-208" />
            </div>
          </motion.div>
        </div>}
      {/* Footer */}
      <Footer data-id="element-209" />
    </div>;
}